export default "__VITE_ASSET__305b84d5__"